// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDfrP_VP1BWo8kPHpDo-PcWMrKgT36JtuI",
  authDomain: "thehiringcompany-97ec4.firebaseapp.com",
  projectId: "thehiringcompany-97ec4",
  storageBucket: "thehiringcompany-97ec4.appspot.com",
  messagingSenderId: "626339099672",
  appId: "1:626339099672:web:aa75291468e6d1ee2c7f6d",
  measurementId: "G-EE17NN1C24"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
